/**
 * 描述：策划资源左侧
 * 日期：2017-8-17
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('planningResourceLeftModule', [])
    .controller('planningResourceLeftCtrl', ['$scope', '$q', '$timeout', '$element', 'trsHttpService', '$state', '$location', function($scope, $q, $timeout, $element, trsHttpService, $state, $location) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                selectedModule: { value: '' },
                basicAccess: {}
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getBasicAccess().then(function() {
                return getCommandAccessAuthority();
            }).then(function() {
                autoLocation();
            });

        }

        /**
         * [autoLocation description] 自动定位
         * @return {[type]} [description]
         */
        function autoLocation() {
            var timer = $timeout(function() {
                if ($state.current.name !== 'front.planningresource') {
                    return;
                }
                var $myResourceLi = $element.find("li[ng-if='permissionData.mysource']"); // 如果有我的资源模块权限，优先展示我的资源
                if ($myResourceLi.length === 1) {
                    $myResourceLi.find('a')[0].click();
                    $myResourceLi.parents('.leve1').eq(0).find('a')[0].click();
                } else { // 如果没有我的资源权限模块，则默认展示第一个
                    $element.find('.leve1').find('a')[0].click();
                    $element.find('.newsLeve2').find('a')[0].click();
                }
            }, 500);
            cancelTimer(timer);
        }
        $scope.$on('expandedThirdLevel', function(event, data) {
            $scope.status.thirdLevelExpanded = data.expanded;
        });

        /**
         * [getBasicAccess description：获取一级模块访问权限
         * @param  {[null]}  [description]
         * @return {[null]}  [description]
         */
        function getBasicAccess() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryMlfChildModalsWithRight',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                .then(function(data) {
                    for (var i = 0; i < data.length; i++) {
                        $scope.status.basicAccess[data[i]] = true;
                    }
                    deffer.resolve();
                });
            return deffer.promise;
        }

        /**
         * [getAccessAuthority description] 获取指挥监测中心访问权限
         * @return {[type]} [description]
         */
        function getCommandAccessAuthority() {
            var deffer = $q.defer();
            var params = {
                methodname: 'queryOperTypesByModal',
                serviceid: 'mlf_metadataright'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                .then(function(data) {
                    $scope.status.basicAccess.commandMonitor = (data.indexOf('dictatemonitor.dictatemonitor') >= 0);
                    deffer.resolve();
                });
            return deffer.promise;
        }

        /**
         * [cancelTimer description] 当控制器被销毁时，立即停止timer里的内容继续执行
         * @param {promise} [timer] [description] 定时器
         * @return {[type]} [description]
         */
        function cancelTimer(timer) {
            $scope.$on('$destroy', function() {
                $timeout.cancel(timer);
            });
        }
    }]);
